import { ensureOk } from "@/api/apiError";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "./httpClient";
import type { CurrentUser } from "@/types";

async function fetchCurrentUser(): Promise<CurrentUser> {
  const response = await httpClient("/me");
  await ensureOk(response);
  return response.json() as Promise<CurrentUser>;
}

/** Fetches the authenticated user + effective RBAC groups (backend is the source of truth). */
export function useCurrentUser() {
  return useQuery({
    queryKey: ["currentUser"],
    queryFn: fetchCurrentUser,
    staleTime: 5 * 60 * 1000,
  });
}
